import script from "./Depositary.vue?vue&type=script&lang=ts&setup=true"
export * from "./Depositary.vue?vue&type=script&lang=ts&setup=true"

import "./Depositary.vue?vue&type=style&index=0&id=0970163e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0970163e"]])

export default __exports__